import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { CommentQuery, OrderReviewAppVo } from './type';

/**
 * 分页查询店铺评价
  GET /api/order/review/store/page
  接口ID：258238093
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-258238093
 */
export const getSpuShopComment = (params: CommentQuery): AxiosPromise<OrderReviewAppVo[]> => {
  return request({
    url: '/api/order/review/store/page',
    method: 'get',
    params
  });
};
